// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/bootstrap/dist/css/bootstrap.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================
   MouseMath — Warm Learning Together Theme
   ======================================== */

:root {
    /* Warm palette — terracotta & amber (reduced pink) */
    --mm-coral: #e07a5f;
    --mm-coral-light: #fdf0eb;
    --mm-coral-dark: #b55a3f;
    --mm-peach: #f2a65a;
    --mm-peach-light: #fdf5eb;
    --mm-yellow: #f4c542;
    --mm-yellow-light: #fef9e7;
    --mm-teal: #06d6a0;
    --mm-teal-light: #e6faf4;
    --mm-teal-dark: #05b88a;
    --mm-lavender: #8b7ec8;
    --mm-lavender-light: #f0edf9;
    --mm-sky: #48cae4;
    --mm-sky-light: #e8f8fd;
    --mm-cream: #fffbf5;
    --mm-warm-gray: #6b5b4e;
    --mm-warm-gray-light: #9a8a7d;
    --mm-dark: #2d2016;
    --mm-dark-soft: #4a3f35;
    --mm-border: #f0e6da;
    --mm-shadow: rgba(45, 32, 22, 0.08);
    --mm-shadow-hover: rgba(45, 32, 22, 0.14);
    --mm-radius: 20px;
    --mm-radius-sm: 12px;
    --mm-radius-pill: 50px;
}

body {
    font-family: "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif;
    line-height: 1.6;
    color: var(--mm-dark);
    background: var(--mm-cream);
    -webkit-font-smoothing: antialiased;
}

/* ===================== Navbar ===================== */
.navbar {
    padding: 12px 0;
    transition: all 0.3s ease;
    background-color: rgba(255, 251, 245, 0.95) !important;
    backdrop-filter: blur(12px);
    border-bottom: 1px solid var(--mm-border);
}

.navbar-brand {
    font-weight: 800 !important;
    font-size: 1.6rem !important;
    color: var(--mm-coral) !important;
    text-decoration: none !important;
    letter-spacing: -0.5px;
}

.navbar-brand:hover {
    color: var(--mm-coral-dark) !important;
}

.nav-link {
    font-weight: 600 !important;
    color: var(--mm-warm-gray) !important;
    margin: 0 6px !important;
    transition: color 0.2s ease !important;
    border-radius: var(--mm-radius-sm);
    padding: 0.5rem 0.75rem !important;
}

.nav-link:hover {
    color: var(--mm-coral) !important;
    background: var(--mm-coral-light) !important;
}

/* ===================== Buttons ===================== */
.btn-mm-primary {
    background: linear-gradient(135deg, var(--mm-coral) 0%, var(--mm-peach) 100%);
    border: none;
    padding: 14px 32px;
    font-weight: 700;
    border-radius: var(--mm-radius-pill);
    color: #fff;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 15px rgba(224, 122, 95, 0.3);
    letter-spacing: 0.3px;
}

.btn-mm-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(224, 122, 95, 0.4);
    color: #fff;
    background: linear-gradient(135deg, var(--mm-coral-dark) 0%, var(--mm-coral) 100%);
}

.btn-mm-secondary {
    border: 2.5px solid var(--mm-teal);
    color: var(--mm-teal-dark);
    padding: 12px 32px;
    font-weight: 700;
    border-radius: var(--mm-radius-pill);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: transparent;
}

.btn-mm-secondary:hover {
    background: var(--mm-teal);
    border-color: var(--mm-teal);
    color: #fff;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(6, 214, 160, 0.3);
}

.btn-mm-teal {
    background: linear-gradient(135deg, var(--mm-teal) 0%, var(--mm-teal-dark) 100%);
    border: none;
    color: #fff;
    padding: 12px 28px;
    font-weight: 700;
    border-radius: var(--mm-radius-pill);
    transition: all 0.3s ease;
    box-shadow: 0 3px 12px rgba(6, 214, 160, 0.25);
}

.btn-mm-teal:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(6, 214, 160, 0.35);
    color: #fff;
}

.btn-mm-yellow {
    background: linear-gradient(135deg, var(--mm-yellow) 0%, #ffc233 100%);
    border: none;
    color: var(--mm-dark);
    padding: 12px 28px;
    font-weight: 700;
    border-radius: var(--mm-radius-pill);
    transition: all 0.3s ease;
    box-shadow: 0 3px 12px rgba(255, 209, 102, 0.3);
}

.btn-mm-yellow:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(255, 209, 102, 0.45);
    color: var(--mm-dark);
}

/* ===================== Cards ===================== */
.card-mm {
    border: none;
    border-radius: var(--mm-radius);
    box-shadow: 0 2px 12px var(--mm-shadow);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    background: #fff;
}

.card-mm:hover {
    box-shadow: 0 8px 30px var(--mm-shadow-hover);
    transform: translateY(-4px);
}

/* ===================== Section titles ===================== */
.section-title {
    font-weight: 800;
    color: var(--mm-dark);
    letter-spacing: -0.5px;
}

.section-subtitle {
    color: var(--mm-warm-gray-light);
    font-size: 1.1rem;
}

/* ===================== Badges ===================== */
.badge-mm {
    font-weight: 600;
    border-radius: var(--mm-radius-pill);
    padding: 6px 14px;
    font-size: 0.82rem;
}

/* All badges use solid saturated backgrounds with white text for guaranteed readability */
.badge-mm-coral {
    background: #d95a4c;
    color: #fff;
}

.badge-mm-teal {
    background: #0d9483;
    color: #fff;
}

.badge-mm-yellow {
    background: #c27800;
    color: #fff;
}

.badge-mm-lavender {
    background: #7c5cbf;
    color: #fff;
}

.badge-mm-sky {
    background: #0891b2;
    color: #fff;
}

/* ===================== Age selector pills ===================== */
.age-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 10px 20px;
    border-radius: var(--mm-radius-pill);
    font-weight: 600;
    font-size: 0.95rem;
    cursor: pointer;
    transition: all 0.25s ease;
    border: 2px solid var(--mm-border);
    background: #fff;
    color: var(--mm-warm-gray);
    -webkit-user-select: none;
            user-select: none;
}

.age-pill:hover {
    border-color: var(--mm-coral);
    color: var(--mm-coral);
    background: var(--mm-coral-light);
    transform: translateY(-2px);
}

.age-pill.active {
    border-color: var(--mm-coral);
    background: var(--mm-coral);
    color: #fff;
    box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
}

/* ===================== Tag filter chips ===================== */
.tag-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px 16px;
    border-radius: var(--mm-radius-pill);
    font-weight: 600;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1.5px solid var(--mm-border);
    background: #fff;
    color: var(--mm-warm-gray);
}

.tag-chip:hover {
    border-color: var(--mm-teal);
    color: var(--mm-teal-dark);
    background: var(--mm-teal-light);
}

.tag-chip.active {
    border-color: var(--mm-teal);
    background: var(--mm-teal);
    color: #fff;
}

.tag-chip-skeleton {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: skeleton-pulse 1.5s ease-in-out infinite;
    cursor: default;
}

/* ===================== Input fields ===================== */
.form-mm {
    border: 2px solid var(--mm-border);
    border-radius: var(--mm-radius-sm);
    padding: 12px 16px;
    font-size: 1rem;
    transition: all 0.2s ease;
    background: #fff;
}

.form-mm:focus {
    border-color: var(--mm-coral);
    box-shadow: 0 0 0 3px rgba(255, 107, 107, 0.15);
    outline: none;
}

/* ===================== Animations ===================== */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes float {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-12px);
    }
}

@keyframes pulse {

    0%,
    100% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.05);
    }
}

.animate-fade-in-up {
    animation: fadeInUp 0.6s ease forwards;
}

/* ===================== Scrollbar ===================== */
::-webkit-scrollbar {
    width: 8px;
}

::-webkit-scrollbar-track {
    background: var(--mm-cream);
}

::-webkit-scrollbar-thumb {
    background: var(--mm-border);
    border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
    background: var(--mm-warm-gray-light);
}

/* ===================== Compact Hero ===================== */
.compact-hero {
    display: flex;
    align-items: center;
    padding: 20px 0 0px;
    text-align: center;
}

.compact-hero-title {
    font-size: 2.8rem;
    font-weight: 800;
    color: var(--mm-dark);
    line-height: 1.2;
}

.compact-hero-title .text-coral {
    color: var(--mm-coral);
}

.compact-hero-subtitle {
    font-size: 1.1rem;
    color: var(--mm-warm-gray);
    line-height: 1.6;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
}

.age-compact-pill {
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1.5px solid var(--mm-border);
    background: #fff;
}

.age-compact-pill:hover {
    background: var(--mm-coral-light);
    border-color: var(--mm-coral);
    color: var(--mm-coral-dark);
}

.age-compact-pill-skeleton {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: skeleton-pulse 1.5s ease-in-out infinite;
}

.skeleton-text {
    color: transparent;
}

@keyframes skeleton-pulse {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}

.compact-hero-actions {
    margin-top: 0.5rem;
}

/* ===================== Age Selector ===================== */
.age-selector-section {
    background: #fff;
    border-top: 1px solid var(--mm-border);
}

.age-group-title {
    font-weight: 700;
    color: var(--mm-dark);
    margin-bottom: 0.5rem;
    font-size: 1.1rem;
}

.age-group-subtitle {
    color: var(--mm-warm-gray-light);
    font-size: 0.9rem;
    margin-bottom: 1rem;
}

/* ===================== Features Section ===================== */
.features-section {
    background: var(--mm-cream);
}

.feature-card {
    text-align: center;
    padding: 2.5rem 1.5rem;
    border-radius: var(--mm-radius);
    background: #fff;
    box-shadow: 0 2px 12px var(--mm-shadow);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    height: 100%;
}

.feature-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 35px var(--mm-shadow-hover);
}

.feature-icon-circle {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1.5rem;
    color: white;
    transition: all 0.3s ease;
}

.feature-card:hover .feature-icon-circle {
    transform: scale(1.1) rotate(5deg);
}

.feature-icon-coral {
    background: linear-gradient(135deg, var(--mm-coral), var(--mm-peach));
}

.feature-icon-teal {
    background: linear-gradient(135deg, var(--mm-teal), var(--mm-teal-dark));
}

.feature-icon-yellow {
    background: linear-gradient(135deg, var(--mm-yellow), #ffc233);
}

.feature-icon-lavender {
    background: linear-gradient(135deg, var(--mm-lavender), #9b88d8);
}

.feature-card h5 {
    color: var(--mm-dark);
    font-weight: 700;
    margin-bottom: 0.75rem;
}

.feature-card p {
    color: var(--mm-warm-gray-light);
    font-size: 0.95rem;
    line-height: 1.6;
    margin-bottom: 0;
}

/* ===================== Materials Section ===================== */
.materials-section {
    background: #fff;
}

.material-card {
    border: none;
    border-radius: var(--mm-radius);
    box-shadow: 0 2px 12px var(--mm-shadow);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    background: #fff;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.material-card:hover {
    box-shadow: 0 8px 30px var(--mm-shadow-hover);
    transform: translateY(-4px);
}

.material-card-img {
    height: 180px;
    object-fit: cover;
    width: 100%;
}

.material-card-body {
    padding: 1.25rem;
    flex: 1 1;
    display: flex;
    flex-direction: column;
}

.material-card-title {
    font-weight: 700;
    color: var(--mm-dark);
    font-size: 1.05rem;
    margin-bottom: 0.5rem;
}

.material-card-title a {
    color: inherit;
    text-decoration: none;
    transition: color 0.2s ease;
}

.material-card-title a:hover {
    color: var(--mm-coral);
}

.material-card-text {
    color: var(--mm-warm-gray-light);
    font-size: 0.9rem;
    line-height: 1.5;
    flex: 1 1;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.material-card-footer {
    padding: 0.75rem 1.25rem 1.25rem;
    border-top: 1px solid var(--mm-border);
}

/* ===================== Methods Section ===================== */
.methods-section {
    background: linear-gradient(160deg, var(--mm-teal-light) 0%, var(--mm-cream) 50%, var(--mm-yellow-light) 100%);
}

.method-card {
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    border-radius: var(--mm-radius);
    padding: 2.5rem;
    box-shadow: 0 2px 12px var(--mm-shadow);
    transition: all 0.3s ease;
    height: 100%;
}

.method-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 30px var(--mm-shadow-hover);
}

.method-icon-circle {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    flex-shrink: 0;
}

.method-features-list {
    list-style: none;
    padding: 0;
    margin: 1rem 0 0;
}

.method-features-list li {
    padding: 6px 0 6px 28px;
    position: relative;
    color: var(--mm-warm-gray);
    font-weight: 500;
}

.method-features-list li::before {
    content: "✓";
    position: absolute;
    left: 0;
    color: var(--mm-teal);
    font-weight: bold;
    font-size: 1.1rem;
}

/* ===================== Browse / Articles Section ===================== */
.browse-section {
    background: var(--mm-cream);
    padding: 10px 0;
}

/* ===================== Age Grid ===================== */
.browse-age-rows {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.browse-age-row {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: center;
}

.browse-header {
    background: linear-gradient(135deg, var(--mm-coral-light) 0%, var(--mm-yellow-light) 100%);
    padding: 50px 0;
    margin: -1px;
    border-radius: 0 0 var(--mm-radius) var(--mm-radius);
}

.browse-filters {
    background: #fff;
    border-radius: var(--mm-radius);
    padding: 24px;
    box-shadow: 0 2px 12px var(--mm-shadow);
    margin-bottom: 30px;
}

.filter-section-title {
    font-weight: 700;
    color: var(--mm-dark);
    font-size: 0.95rem;
    margin-bottom: 12px;
    margin-top: 16px;
}

.filter-section-title:first-child {
    margin-top: 0;
}

/* ===================== Article Detail ===================== */
.article-hero {
    background: linear-gradient(135deg, var(--mm-coral-light) 0%, var(--mm-yellow-light) 50%, var(--mm-teal-light) 100%);
    padding: 8px 0 14px;
    margin: -1px;
    border-radius: 0 0 var(--mm-radius) var(--mm-radius);
}

.article-price-card {
    background: #fff;
    border-radius: var(--mm-radius);
    padding: 2rem;
    box-shadow: 0 4px 20px var(--mm-shadow);
    text-align: center;
}

.article-content-area {
    background: #fff;
    border-radius: var(--mm-radius);
    padding: 2.5rem;
    box-shadow: 0 2px 12px var(--mm-shadow);
}

.article-content-area h1,
.article-content-area h2,
.article-content-area h3,
.article-content-area h4 {
    color: var(--mm-dark);
    font-weight: 700;
    margin-top: 1.5em;
    margin-bottom: 0.75em;
}

.article-content-area p {
    margin-bottom: 1.2em;
    color: var(--mm-dark-soft);
}

.article-content-area blockquote {
    border-left: 4px solid var(--mm-coral);
    padding: 1rem 1.5rem;
    margin: 1.5em 0;
    background: var(--mm-coral-light);
    border-radius: 0 var(--mm-radius-sm) var(--mm-radius-sm) 0;
    color: var(--mm-dark-soft);
}

.article-content-area code {
    background: var(--mm-cream);
    padding: 2px 8px;
    border-radius: 6px;
    font-size: 0.9em;
}

.article-content-area pre {
    background: var(--mm-dark);
    color: #ecf0f1;
    padding: 1.5rem;
    border-radius: var(--mm-radius-sm);
    overflow-x: auto;
}

.article-content-area img {
    max-width: 100%;
    border-radius: var(--mm-radius-sm);
    margin: 1.5em 0;
}

/* ===================== Login / Register ===================== */
.auth-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    background: linear-gradient(160deg, var(--mm-cream) 0%, var(--mm-coral-light) 50%, var(--mm-yellow-light) 100%);
    padding: 100px 0;
}

.auth-card {
    background: #fff;
    border-radius: var(--mm-radius);
    padding: 2.5rem;
    box-shadow: 0 8px 40px var(--mm-shadow-hover);
    max-width: 440px;
    margin: 0 auto;
    width: 100%;
}

.auth-logo {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1.5rem;
    color: white;
}

/* ===================== Footer ===================== */
.footer {
    background: var(--mm-dark);
    color: rgba(255, 255, 255, 0.8);
    padding: 60px 0 30px;
    margin-top: 60px;
}

.footer h5 {
    color: #fff;
    font-weight: 700;
    margin-bottom: 1.2rem;
}

.footer a {
    color: rgba(255, 255, 255, 0.6);
    text-decoration: none;
    transition: color 0.2s ease;
}

.footer a:hover {
    color: var(--mm-coral);
}

.footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 1.5rem;
    margin-top: 2rem;
}

/* ===================== User Profile ===================== */
.profile-page {
    min-height: calc(100vh - 56px);
    padding-top: 80px;
    background: var(--mm-cream);
}

.profile-card {
    background: #fff;
    border-radius: var(--mm-radius);
    padding: 2.5rem;
    box-shadow: 0 4px 20px var(--mm-shadow);
    max-width: 480px;
    margin: 0 auto;
}

/* ===================== Purchases ===================== */
.purchases-page {
    min-height: calc(100vh - 56px);
    padding-top: 80px;
    background: var(--mm-cream);
}

.purchase-card {
    background: #fff;
    border-radius: var(--mm-radius);
    padding: 1.5rem;
    box-shadow: 0 2px 12px var(--mm-shadow);
    transition: all 0.3s ease;
}

.purchase-card:hover {
    box-shadow: 0 6px 25px var(--mm-shadow-hover);
}

/* ===================== Privacy / Terms ===================== */
.legal-page {
    min-height: calc(100vh - 56px);
    padding-top: 10px;
    padding-bottom: 60px;
    background: var(--mm-cream);
}

.legal-content {
    background: #fff;
    border-radius: var(--mm-radius);
    padding: 3rem;
    box-shadow: 0 2px 12px var(--mm-shadow);
}

.legal-content h1 {
    font-weight: 800;
    color: var(--mm-dark);
    margin-bottom: 1rem;
}

.legal-content h5 {
    font-weight: 700;
    color: var(--mm-dark);
    margin-top: 2rem;
    margin-bottom: 0.75rem;
}

/* ===================== Responsive ===================== */
@media (max-width: 768px) {
    .compact-hero {
        padding: 50px 0 40px;
    }

    .compact-hero-title {
        font-size: 2rem;
    }

    .compact-hero-subtitle {
        font-size: 1rem;
    }

    .section-title {
        font-size: 1.8rem;
    }

    .browse-header {
        padding: 30px 0;
    }

    .browse-filters {
        padding: 16px;
    }

    .article-hero {
        padding: 80px 0 30px;
    }

    .article-content-area {
        padding: 1.5rem;
    }

    .auth-card {
        padding: 1.5rem;
        margin: 0 1rem;
    }

    .legal-content {
        padding: 1.5rem;
    }

    .method-card {
        padding: 1.5rem;
        margin-bottom: 1rem;
    }

    .feature-card {
        padding: 1.5rem;
        margin-bottom: 1rem;
    }
}

/* ===================== Admin overrides (keep existing) ===================== */
.admin-dashboard {
    background: var(--mm-cream);
    flex-grow: 1;
}

.admin-header {
    background: white;
    border-bottom: 1px solid #e9ecef;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.admin-sidebar {
    padding: 20px 0;
}

.admin-sidebar .nav-pills .nav-link {
    border-radius: 10px;
    margin-bottom: 5px;
    color: #6c757d;
    font-weight: 500;
    transition: all 0.3s ease;
}

.admin-sidebar .nav-pills .nav-link:hover {
    background: var(--mm-coral-light);
    color: var(--mm-coral);
}

.admin-sidebar .nav-pills .nav-link.active {
    background: var(--mm-coral);
    color: white;
}

.admin-content {
    padding: 20px;
}

.tags-manager .table th {
    background: var(--mm-coral-light);
    border: none;
    font-weight: 600;
    color: var(--mm-coral-dark);
}

.tags-manager .table td {
    vertical-align: middle;
    border-color: #f8f9fa;
}

.articles-manager .table th {
    background: var(--mm-coral-light);
    border: none;
    font-weight: 600;
    color: var(--mm-coral-dark);
}

.articles-manager .table td {
    vertical-align: middle;
    border-color: #f8f9fa;
}

.article-editor .nav-tabs {
    border-bottom: 2px solid var(--mm-coral-light);
}

.article-editor .nav-tabs .nav-link {
    border: none;
    color: #6c757d;
    font-weight: 500;
    padding: 12px 20px;
    border-radius: var(--mm-radius-sm) var(--mm-radius-sm) 0 0;
}

.article-editor .nav-tabs .nav-link:hover {
    border-color: transparent;
    color: var(--mm-coral);
}

.article-editor .nav-tabs .nav-link.active {
    background: var(--mm-coral);
    color: white;
    border-color: var(--mm-coral);
}

.cursor-pointer {
    cursor: pointer;
}

@media (max-width: 768px) {
    .admin-sidebar {
        padding: 10px;
    }

    .admin-content {
        padding: 10px;
    }

    .admin-sidebar .nav-pills {
        flex-direction: row;
        overflow-x: auto;
    }

    .admin-sidebar .nav-pills .nav-link {
        white-space: nowrap;
        margin-right: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/AppNew.css"],"names":[],"mappings":"AAEA;;6CAE6C;;AAE7C;IACI,qDAAqD;IACrD,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;IACxB,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,0BAA0B;IAC1B,kBAAkB;IAClB,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,4BAA4B;IAC5B,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;IACpB,mCAAmC;IACnC,yCAAyC;IACzC,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,sEAAsE;IACtE,gBAAgB;IAChB,qBAAqB;IACrB,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA,uDAAuD;AACvD;IACI,eAAe;IACf,yBAAyB;IACzB,sDAAsD;IACtD,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,iCAAiC;IACjC,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;IAC3B,qCAAqC;IACrC,wBAAwB;IACxB,sCAAsC;IACtC,kCAAkC;IAClC,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;IACjC,4CAA4C;AAChD;;AAEA,wDAAwD;AACxD;IACI,6EAA6E;IAC7E,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,oCAAoC;IACpC,WAAW;IACX,iDAAiD;IACjD,8CAA8C;IAC9C,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,WAAW;IACX,kFAAkF;AACtF;;AAEA;IACI,kCAAkC;IAClC,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,oCAAoC;IACpC,iDAAiD;IACjD,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;IACX,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,gFAAgF;IAChF,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,oCAAoC;IACpC,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,WAAW;AACf;;AAEA;IACI,sEAAsE;IACtE,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,oCAAoC;IACpC,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;IAChD,qBAAqB;AACzB;;AAEA,sDAAsD;AACtD;IACI,YAAY;IACZ,+BAA+B;IAC/B,uCAAuC;IACvC,iDAAiD;IACjD,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;IAC7C,2BAA2B;AAC/B;;AAEA,+DAA+D;AAC/D;IACI,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA,uDAAuD;AACvD;IACI,gBAAgB;IAChB,oCAAoC;IACpC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,0FAA0F;AAC1F;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA,mEAAmE;AACnE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,kCAAkC;IAClC,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,WAAW;IACX,+CAA+C;AACnD;;AAEA,iEAAiE;AACjE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,oCAAoC;IACpC,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI,4BAA4B;IAC5B,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,yEAAyE;IACzE,0BAA0B;IAC1B,mDAAmD;IACnD,eAAe;AACnB;;AAEA,6DAA6D;AAC7D;IACI,kCAAkC;IAClC,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,+CAA+C;IAC/C,aAAa;AACjB;;AAEA,2DAA2D;AAC3D;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;IAEI;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,0DAA0D;AAC1D;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA,6DAA6D;AAC7D;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,yEAAyE;IACzE,0BAA0B;IAC1B,mDAAmD;AACvD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA,6DAA6D;AAC7D;IACI,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,iEAAiE;AACjE;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,+BAA+B;IAC/B,gBAAgB;IAChB,uCAAuC;IACvC,iDAAiD;IACjD,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qEAAqE;AACzE;;AAEA;IACI,wEAAwE;AAC5E;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,kEAAkE;AAClE;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,uCAAuC;IACvC,iDAAiD;IACjD,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,6CAA6C;IAC7C,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,SAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,SAAO;IACP,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA,gEAAgE;AAChE;IACI,8GAA8G;AAClH;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,+BAA+B;IAC/B,eAAe;IACf,uCAAuC;IACvC,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,0EAA0E;AAC1E;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,0FAA0F;IAC1F,eAAe;IACf,YAAY;IACZ,oDAAoD;AACxD;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,aAAa;IACb,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA,+DAA+D;AAC/D;IACI,oHAAoH;IACpH,mBAAmB;IACnB,YAAY;IACZ,oDAAoD;AACxD;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,aAAa;IACb,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;IACf,uCAAuC;AAC3C;;AAEA;;;;IAII,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,0BAA0B;AAC9B;;AAEA;IACI,sCAAsC;IACtC,oBAAoB;IACpB,eAAe;IACf,iCAAiC;IACjC,0DAA0D;IAC1D,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,eAAe;IACf,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,eAAe;AACnB;;AAEA,iEAAiE;AACjE;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,+GAA+G;IAC/G,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;IACf,6CAA6C;IAC7C,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;AAChB;;AAEA,uDAAuD;AACvD;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;IAC/B,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,8CAA8C;IAC9C,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,6DAA6D;AAC7D;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;IACf,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;AAClB;;AAEA,0DAA0D;AAC1D;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;IACf,uCAAuC;IACvC,yBAAyB;AAC7B;;AAEA;IACI,6CAA6C;AACjD;;AAEA,gEAAgE;AAChE;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,aAAa;IACb,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,2DAA2D;AAC3D;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;AACJ;;AAEA,gFAAgF;AAChF;IACI,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,yCAAyC;AAC7C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,0DAA0D;AAC9D;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;AACJ","sourcesContent":["@import \"bootstrap/dist/css/bootstrap.min.css\";\n\n/* ========================================\n   MouseMath — Warm Learning Together Theme\n   ======================================== */\n\n:root {\n    /* Warm palette — terracotta & amber (reduced pink) */\n    --mm-coral: #e07a5f;\n    --mm-coral-light: #fdf0eb;\n    --mm-coral-dark: #b55a3f;\n    --mm-peach: #f2a65a;\n    --mm-peach-light: #fdf5eb;\n    --mm-yellow: #f4c542;\n    --mm-yellow-light: #fef9e7;\n    --mm-teal: #06d6a0;\n    --mm-teal-light: #e6faf4;\n    --mm-teal-dark: #05b88a;\n    --mm-lavender: #8b7ec8;\n    --mm-lavender-light: #f0edf9;\n    --mm-sky: #48cae4;\n    --mm-sky-light: #e8f8fd;\n    --mm-cream: #fffbf5;\n    --mm-warm-gray: #6b5b4e;\n    --mm-warm-gray-light: #9a8a7d;\n    --mm-dark: #2d2016;\n    --mm-dark-soft: #4a3f35;\n    --mm-border: #f0e6da;\n    --mm-shadow: rgba(45, 32, 22, 0.08);\n    --mm-shadow-hover: rgba(45, 32, 22, 0.14);\n    --mm-radius: 20px;\n    --mm-radius-sm: 12px;\n    --mm-radius-pill: 50px;\n}\n\nbody {\n    font-family: \"Segoe UI\", \"Roboto\", \"Helvetica Neue\", Arial, sans-serif;\n    line-height: 1.6;\n    color: var(--mm-dark);\n    background: var(--mm-cream);\n    -webkit-font-smoothing: antialiased;\n}\n\n/* ===================== Navbar ===================== */\n.navbar {\n    padding: 12px 0;\n    transition: all 0.3s ease;\n    background-color: rgba(255, 251, 245, 0.95) !important;\n    backdrop-filter: blur(12px);\n    border-bottom: 1px solid var(--mm-border);\n}\n\n.navbar-brand {\n    font-weight: 800 !important;\n    font-size: 1.6rem !important;\n    color: var(--mm-coral) !important;\n    text-decoration: none !important;\n    letter-spacing: -0.5px;\n}\n\n.navbar-brand:hover {\n    color: var(--mm-coral-dark) !important;\n}\n\n.nav-link {\n    font-weight: 600 !important;\n    color: var(--mm-warm-gray) !important;\n    margin: 0 6px !important;\n    transition: color 0.2s ease !important;\n    border-radius: var(--mm-radius-sm);\n    padding: 0.5rem 0.75rem !important;\n}\n\n.nav-link:hover {\n    color: var(--mm-coral) !important;\n    background: var(--mm-coral-light) !important;\n}\n\n/* ===================== Buttons ===================== */\n.btn-mm-primary {\n    background: linear-gradient(135deg, var(--mm-coral) 0%, var(--mm-peach) 100%);\n    border: none;\n    padding: 14px 32px;\n    font-weight: 700;\n    border-radius: var(--mm-radius-pill);\n    color: #fff;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    box-shadow: 0 4px 15px rgba(224, 122, 95, 0.3);\n    letter-spacing: 0.3px;\n}\n\n.btn-mm-primary:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 25px rgba(224, 122, 95, 0.4);\n    color: #fff;\n    background: linear-gradient(135deg, var(--mm-coral-dark) 0%, var(--mm-coral) 100%);\n}\n\n.btn-mm-secondary {\n    border: 2.5px solid var(--mm-teal);\n    color: var(--mm-teal-dark);\n    padding: 12px 32px;\n    font-weight: 700;\n    border-radius: var(--mm-radius-pill);\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    background: transparent;\n}\n\n.btn-mm-secondary:hover {\n    background: var(--mm-teal);\n    border-color: var(--mm-teal);\n    color: #fff;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(6, 214, 160, 0.3);\n}\n\n.btn-mm-teal {\n    background: linear-gradient(135deg, var(--mm-teal) 0%, var(--mm-teal-dark) 100%);\n    border: none;\n    color: #fff;\n    padding: 12px 28px;\n    font-weight: 700;\n    border-radius: var(--mm-radius-pill);\n    transition: all 0.3s ease;\n    box-shadow: 0 3px 12px rgba(6, 214, 160, 0.25);\n}\n\n.btn-mm-teal:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 20px rgba(6, 214, 160, 0.35);\n    color: #fff;\n}\n\n.btn-mm-yellow {\n    background: linear-gradient(135deg, var(--mm-yellow) 0%, #ffc233 100%);\n    border: none;\n    color: var(--mm-dark);\n    padding: 12px 28px;\n    font-weight: 700;\n    border-radius: var(--mm-radius-pill);\n    transition: all 0.3s ease;\n    box-shadow: 0 3px 12px rgba(255, 209, 102, 0.3);\n}\n\n.btn-mm-yellow:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 20px rgba(255, 209, 102, 0.45);\n    color: var(--mm-dark);\n}\n\n/* ===================== Cards ===================== */\n.card-mm {\n    border: none;\n    border-radius: var(--mm-radius);\n    box-shadow: 0 2px 12px var(--mm-shadow);\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    overflow: hidden;\n    background: #fff;\n}\n\n.card-mm:hover {\n    box-shadow: 0 8px 30px var(--mm-shadow-hover);\n    transform: translateY(-4px);\n}\n\n/* ===================== Section titles ===================== */\n.section-title {\n    font-weight: 800;\n    color: var(--mm-dark);\n    letter-spacing: -0.5px;\n}\n\n.section-subtitle {\n    color: var(--mm-warm-gray-light);\n    font-size: 1.1rem;\n}\n\n/* ===================== Badges ===================== */\n.badge-mm {\n    font-weight: 600;\n    border-radius: var(--mm-radius-pill);\n    padding: 6px 14px;\n    font-size: 0.82rem;\n}\n\n/* All badges use solid saturated backgrounds with white text for guaranteed readability */\n.badge-mm-coral {\n    background: #d95a4c;\n    color: #fff;\n}\n\n.badge-mm-teal {\n    background: #0d9483;\n    color: #fff;\n}\n\n.badge-mm-yellow {\n    background: #c27800;\n    color: #fff;\n}\n\n.badge-mm-lavender {\n    background: #7c5cbf;\n    color: #fff;\n}\n\n.badge-mm-sky {\n    background: #0891b2;\n    color: #fff;\n}\n\n/* ===================== Age selector pills ===================== */\n.age-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 10px 20px;\n    border-radius: var(--mm-radius-pill);\n    font-weight: 600;\n    font-size: 0.95rem;\n    cursor: pointer;\n    transition: all 0.25s ease;\n    border: 2px solid var(--mm-border);\n    background: #fff;\n    color: var(--mm-warm-gray);\n    user-select: none;\n}\n\n.age-pill:hover {\n    border-color: var(--mm-coral);\n    color: var(--mm-coral);\n    background: var(--mm-coral-light);\n    transform: translateY(-2px);\n}\n\n.age-pill.active {\n    border-color: var(--mm-coral);\n    background: var(--mm-coral);\n    color: #fff;\n    box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);\n}\n\n/* ===================== Tag filter chips ===================== */\n.tag-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 6px 16px;\n    border-radius: var(--mm-radius-pill);\n    font-weight: 600;\n    font-size: 0.85rem;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: 1.5px solid var(--mm-border);\n    background: #fff;\n    color: var(--mm-warm-gray);\n}\n\n.tag-chip:hover {\n    border-color: var(--mm-teal);\n    color: var(--mm-teal-dark);\n    background: var(--mm-teal-light);\n}\n\n.tag-chip.active {\n    border-color: var(--mm-teal);\n    background: var(--mm-teal);\n    color: #fff;\n}\n\n.tag-chip-skeleton {\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n    background-size: 200% 100%;\n    animation: skeleton-pulse 1.5s ease-in-out infinite;\n    cursor: default;\n}\n\n/* ===================== Input fields ===================== */\n.form-mm {\n    border: 2px solid var(--mm-border);\n    border-radius: var(--mm-radius-sm);\n    padding: 12px 16px;\n    font-size: 1rem;\n    transition: all 0.2s ease;\n    background: #fff;\n}\n\n.form-mm:focus {\n    border-color: var(--mm-coral);\n    box-shadow: 0 0 0 3px rgba(255, 107, 107, 0.15);\n    outline: none;\n}\n\n/* ===================== Animations ===================== */\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes float {\n\n    0%,\n    100% {\n        transform: translateY(0);\n    }\n\n    50% {\n        transform: translateY(-12px);\n    }\n}\n\n@keyframes pulse {\n\n    0%,\n    100% {\n        transform: scale(1);\n    }\n\n    50% {\n        transform: scale(1.05);\n    }\n}\n\n.animate-fade-in-up {\n    animation: fadeInUp 0.6s ease forwards;\n}\n\n/* ===================== Scrollbar ===================== */\n::-webkit-scrollbar {\n    width: 8px;\n}\n\n::-webkit-scrollbar-track {\n    background: var(--mm-cream);\n}\n\n::-webkit-scrollbar-thumb {\n    background: var(--mm-border);\n    border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: var(--mm-warm-gray-light);\n}\n\n/* ===================== Compact Hero ===================== */\n.compact-hero {\n    display: flex;\n    align-items: center;\n    padding: 20px 0 0px;\n    text-align: center;\n}\n\n.compact-hero-title {\n    font-size: 2.8rem;\n    font-weight: 800;\n    color: var(--mm-dark);\n    line-height: 1.2;\n}\n\n.compact-hero-title .text-coral {\n    color: var(--mm-coral);\n}\n\n.compact-hero-subtitle {\n    font-size: 1.1rem;\n    color: var(--mm-warm-gray);\n    line-height: 1.6;\n    max-width: 600px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.age-compact-pill {\n    font-size: 0.9rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: 1.5px solid var(--mm-border);\n    background: #fff;\n}\n\n.age-compact-pill:hover {\n    background: var(--mm-coral-light);\n    border-color: var(--mm-coral);\n    color: var(--mm-coral-dark);\n}\n\n.age-compact-pill-skeleton {\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n    background-size: 200% 100%;\n    animation: skeleton-pulse 1.5s ease-in-out infinite;\n}\n\n.skeleton-text {\n    color: transparent;\n}\n\n@keyframes skeleton-pulse {\n    0% {\n        background-position: 200% 0;\n    }\n    100% {\n        background-position: -200% 0;\n    }\n}\n\n.compact-hero-actions {\n    margin-top: 0.5rem;\n}\n\n/* ===================== Age Selector ===================== */\n.age-selector-section {\n    background: #fff;\n    border-top: 1px solid var(--mm-border);\n}\n\n.age-group-title {\n    font-weight: 700;\n    color: var(--mm-dark);\n    margin-bottom: 0.5rem;\n    font-size: 1.1rem;\n}\n\n.age-group-subtitle {\n    color: var(--mm-warm-gray-light);\n    font-size: 0.9rem;\n    margin-bottom: 1rem;\n}\n\n/* ===================== Features Section ===================== */\n.features-section {\n    background: var(--mm-cream);\n}\n\n.feature-card {\n    text-align: center;\n    padding: 2.5rem 1.5rem;\n    border-radius: var(--mm-radius);\n    background: #fff;\n    box-shadow: 0 2px 12px var(--mm-shadow);\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    height: 100%;\n}\n\n.feature-card:hover {\n    transform: translateY(-6px);\n    box-shadow: 0 12px 35px var(--mm-shadow-hover);\n}\n\n.feature-icon-circle {\n    width: 72px;\n    height: 72px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 1.5rem;\n    color: white;\n    transition: all 0.3s ease;\n}\n\n.feature-card:hover .feature-icon-circle {\n    transform: scale(1.1) rotate(5deg);\n}\n\n.feature-icon-coral {\n    background: linear-gradient(135deg, var(--mm-coral), var(--mm-peach));\n}\n\n.feature-icon-teal {\n    background: linear-gradient(135deg, var(--mm-teal), var(--mm-teal-dark));\n}\n\n.feature-icon-yellow {\n    background: linear-gradient(135deg, var(--mm-yellow), #ffc233);\n}\n\n.feature-icon-lavender {\n    background: linear-gradient(135deg, var(--mm-lavender), #9b88d8);\n}\n\n.feature-card h5 {\n    color: var(--mm-dark);\n    font-weight: 700;\n    margin-bottom: 0.75rem;\n}\n\n.feature-card p {\n    color: var(--mm-warm-gray-light);\n    font-size: 0.95rem;\n    line-height: 1.6;\n    margin-bottom: 0;\n}\n\n/* ===================== Materials Section ===================== */\n.materials-section {\n    background: #fff;\n}\n\n.material-card {\n    border: none;\n    border-radius: var(--mm-radius);\n    box-shadow: 0 2px 12px var(--mm-shadow);\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    overflow: hidden;\n    background: #fff;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.material-card:hover {\n    box-shadow: 0 8px 30px var(--mm-shadow-hover);\n    transform: translateY(-4px);\n}\n\n.material-card-img {\n    height: 180px;\n    object-fit: cover;\n    width: 100%;\n}\n\n.material-card-body {\n    padding: 1.25rem;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.material-card-title {\n    font-weight: 700;\n    color: var(--mm-dark);\n    font-size: 1.05rem;\n    margin-bottom: 0.5rem;\n}\n\n.material-card-title a {\n    color: inherit;\n    text-decoration: none;\n    transition: color 0.2s ease;\n}\n\n.material-card-title a:hover {\n    color: var(--mm-coral);\n}\n\n.material-card-text {\n    color: var(--mm-warm-gray-light);\n    font-size: 0.9rem;\n    line-height: 1.5;\n    flex: 1;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.material-card-footer {\n    padding: 0.75rem 1.25rem 1.25rem;\n    border-top: 1px solid var(--mm-border);\n}\n\n/* ===================== Methods Section ===================== */\n.methods-section {\n    background: linear-gradient(160deg, var(--mm-teal-light) 0%, var(--mm-cream) 50%, var(--mm-yellow-light) 100%);\n}\n\n.method-card {\n    background: rgba(255, 255, 255, 0.85);\n    backdrop-filter: blur(10px);\n    border-radius: var(--mm-radius);\n    padding: 2.5rem;\n    box-shadow: 0 2px 12px var(--mm-shadow);\n    transition: all 0.3s ease;\n    height: 100%;\n}\n\n.method-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 8px 30px var(--mm-shadow-hover);\n}\n\n.method-icon-circle {\n    width: 56px;\n    height: 56px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    flex-shrink: 0;\n}\n\n.method-features-list {\n    list-style: none;\n    padding: 0;\n    margin: 1rem 0 0;\n}\n\n.method-features-list li {\n    padding: 6px 0 6px 28px;\n    position: relative;\n    color: var(--mm-warm-gray);\n    font-weight: 500;\n}\n\n.method-features-list li::before {\n    content: \"✓\";\n    position: absolute;\n    left: 0;\n    color: var(--mm-teal);\n    font-weight: bold;\n    font-size: 1.1rem;\n}\n\n/* ===================== Browse / Articles Section ===================== */\n.browse-section {\n    background: var(--mm-cream);\n    padding: 10px 0;\n}\n\n/* ===================== Age Grid ===================== */\n.browse-age-rows {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.browse-age-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    justify-content: center;\n}\n\n.browse-header {\n    background: linear-gradient(135deg, var(--mm-coral-light) 0%, var(--mm-yellow-light) 100%);\n    padding: 50px 0;\n    margin: -1px;\n    border-radius: 0 0 var(--mm-radius) var(--mm-radius);\n}\n\n.browse-filters {\n    background: #fff;\n    border-radius: var(--mm-radius);\n    padding: 24px;\n    box-shadow: 0 2px 12px var(--mm-shadow);\n    margin-bottom: 30px;\n}\n\n.filter-section-title {\n    font-weight: 700;\n    color: var(--mm-dark);\n    font-size: 0.95rem;\n    margin-bottom: 12px;\n    margin-top: 16px;\n}\n\n.filter-section-title:first-child {\n    margin-top: 0;\n}\n\n/* ===================== Article Detail ===================== */\n.article-hero {\n    background: linear-gradient(135deg, var(--mm-coral-light) 0%, var(--mm-yellow-light) 50%, var(--mm-teal-light) 100%);\n    padding: 8px 0 14px;\n    margin: -1px;\n    border-radius: 0 0 var(--mm-radius) var(--mm-radius);\n}\n\n.article-price-card {\n    background: #fff;\n    border-radius: var(--mm-radius);\n    padding: 2rem;\n    box-shadow: 0 4px 20px var(--mm-shadow);\n    text-align: center;\n}\n\n.article-content-area {\n    background: #fff;\n    border-radius: var(--mm-radius);\n    padding: 2.5rem;\n    box-shadow: 0 2px 12px var(--mm-shadow);\n}\n\n.article-content-area h1,\n.article-content-area h2,\n.article-content-area h3,\n.article-content-area h4 {\n    color: var(--mm-dark);\n    font-weight: 700;\n    margin-top: 1.5em;\n    margin-bottom: 0.75em;\n}\n\n.article-content-area p {\n    margin-bottom: 1.2em;\n    color: var(--mm-dark-soft);\n}\n\n.article-content-area blockquote {\n    border-left: 4px solid var(--mm-coral);\n    padding: 1rem 1.5rem;\n    margin: 1.5em 0;\n    background: var(--mm-coral-light);\n    border-radius: 0 var(--mm-radius-sm) var(--mm-radius-sm) 0;\n    color: var(--mm-dark-soft);\n}\n\n.article-content-area code {\n    background: var(--mm-cream);\n    padding: 2px 8px;\n    border-radius: 6px;\n    font-size: 0.9em;\n}\n\n.article-content-area pre {\n    background: var(--mm-dark);\n    color: #ecf0f1;\n    padding: 1.5rem;\n    border-radius: var(--mm-radius-sm);\n    overflow-x: auto;\n}\n\n.article-content-area img {\n    max-width: 100%;\n    border-radius: var(--mm-radius-sm);\n    margin: 1.5em 0;\n}\n\n/* ===================== Login / Register ===================== */\n.auth-page {\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    background: linear-gradient(160deg, var(--mm-cream) 0%, var(--mm-coral-light) 50%, var(--mm-yellow-light) 100%);\n    padding: 100px 0;\n}\n\n.auth-card {\n    background: #fff;\n    border-radius: var(--mm-radius);\n    padding: 2.5rem;\n    box-shadow: 0 8px 40px var(--mm-shadow-hover);\n    max-width: 440px;\n    margin: 0 auto;\n    width: 100%;\n}\n\n.auth-logo {\n    width: 64px;\n    height: 64px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 1.5rem;\n    color: white;\n}\n\n/* ===================== Footer ===================== */\n.footer {\n    background: var(--mm-dark);\n    color: rgba(255, 255, 255, 0.8);\n    padding: 60px 0 30px;\n    margin-top: 60px;\n}\n\n.footer h5 {\n    color: #fff;\n    font-weight: 700;\n    margin-bottom: 1.2rem;\n}\n\n.footer a {\n    color: rgba(255, 255, 255, 0.6);\n    text-decoration: none;\n    transition: color 0.2s ease;\n}\n\n.footer a:hover {\n    color: var(--mm-coral);\n}\n\n.footer-bottom {\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n    padding-top: 1.5rem;\n    margin-top: 2rem;\n}\n\n/* ===================== User Profile ===================== */\n.profile-page {\n    min-height: calc(100vh - 56px);\n    padding-top: 80px;\n    background: var(--mm-cream);\n}\n\n.profile-card {\n    background: #fff;\n    border-radius: var(--mm-radius);\n    padding: 2.5rem;\n    box-shadow: 0 4px 20px var(--mm-shadow);\n    max-width: 480px;\n    margin: 0 auto;\n}\n\n/* ===================== Purchases ===================== */\n.purchases-page {\n    min-height: calc(100vh - 56px);\n    padding-top: 80px;\n    background: var(--mm-cream);\n}\n\n.purchase-card {\n    background: #fff;\n    border-radius: var(--mm-radius);\n    padding: 1.5rem;\n    box-shadow: 0 2px 12px var(--mm-shadow);\n    transition: all 0.3s ease;\n}\n\n.purchase-card:hover {\n    box-shadow: 0 6px 25px var(--mm-shadow-hover);\n}\n\n/* ===================== Privacy / Terms ===================== */\n.legal-page {\n    min-height: calc(100vh - 56px);\n    padding-top: 10px;\n    padding-bottom: 60px;\n    background: var(--mm-cream);\n}\n\n.legal-content {\n    background: #fff;\n    border-radius: var(--mm-radius);\n    padding: 3rem;\n    box-shadow: 0 2px 12px var(--mm-shadow);\n}\n\n.legal-content h1 {\n    font-weight: 800;\n    color: var(--mm-dark);\n    margin-bottom: 1rem;\n}\n\n.legal-content h5 {\n    font-weight: 700;\n    color: var(--mm-dark);\n    margin-top: 2rem;\n    margin-bottom: 0.75rem;\n}\n\n/* ===================== Responsive ===================== */\n@media (max-width: 768px) {\n    .compact-hero {\n        padding: 50px 0 40px;\n    }\n\n    .compact-hero-title {\n        font-size: 2rem;\n    }\n\n    .compact-hero-subtitle {\n        font-size: 1rem;\n    }\n\n    .section-title {\n        font-size: 1.8rem;\n    }\n\n    .browse-header {\n        padding: 30px 0;\n    }\n\n    .browse-filters {\n        padding: 16px;\n    }\n\n    .article-hero {\n        padding: 80px 0 30px;\n    }\n\n    .article-content-area {\n        padding: 1.5rem;\n    }\n\n    .auth-card {\n        padding: 1.5rem;\n        margin: 0 1rem;\n    }\n\n    .legal-content {\n        padding: 1.5rem;\n    }\n\n    .method-card {\n        padding: 1.5rem;\n        margin-bottom: 1rem;\n    }\n\n    .feature-card {\n        padding: 1.5rem;\n        margin-bottom: 1rem;\n    }\n}\n\n/* ===================== Admin overrides (keep existing) ===================== */\n.admin-dashboard {\n    background: var(--mm-cream);\n    flex-grow: 1;\n}\n\n.admin-header {\n    background: white;\n    border-bottom: 1px solid #e9ecef;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);\n}\n\n.admin-sidebar {\n    padding: 20px 0;\n}\n\n.admin-sidebar .nav-pills .nav-link {\n    border-radius: 10px;\n    margin-bottom: 5px;\n    color: #6c757d;\n    font-weight: 500;\n    transition: all 0.3s ease;\n}\n\n.admin-sidebar .nav-pills .nav-link:hover {\n    background: var(--mm-coral-light);\n    color: var(--mm-coral);\n}\n\n.admin-sidebar .nav-pills .nav-link.active {\n    background: var(--mm-coral);\n    color: white;\n}\n\n.admin-content {\n    padding: 20px;\n}\n\n.tags-manager .table th {\n    background: var(--mm-coral-light);\n    border: none;\n    font-weight: 600;\n    color: var(--mm-coral-dark);\n}\n\n.tags-manager .table td {\n    vertical-align: middle;\n    border-color: #f8f9fa;\n}\n\n.articles-manager .table th {\n    background: var(--mm-coral-light);\n    border: none;\n    font-weight: 600;\n    color: var(--mm-coral-dark);\n}\n\n.articles-manager .table td {\n    vertical-align: middle;\n    border-color: #f8f9fa;\n}\n\n.article-editor .nav-tabs {\n    border-bottom: 2px solid var(--mm-coral-light);\n}\n\n.article-editor .nav-tabs .nav-link {\n    border: none;\n    color: #6c757d;\n    font-weight: 500;\n    padding: 12px 20px;\n    border-radius: var(--mm-radius-sm) var(--mm-radius-sm) 0 0;\n}\n\n.article-editor .nav-tabs .nav-link:hover {\n    border-color: transparent;\n    color: var(--mm-coral);\n}\n\n.article-editor .nav-tabs .nav-link.active {\n    background: var(--mm-coral);\n    color: white;\n    border-color: var(--mm-coral);\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}\n\n@media (max-width: 768px) {\n    .admin-sidebar {\n        padding: 10px;\n    }\n\n    .admin-content {\n        padding: 10px;\n    }\n\n    .admin-sidebar .nav-pills {\n        flex-direction: row;\n        overflow-x: auto;\n    }\n\n    .admin-sidebar .nav-pills .nav-link {\n        white-space: nowrap;\n        margin-right: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
